<app-loader *ngIf="!screen" [isLoading]="!screen" class="load-indicator" id="MainConsoleDisplay"></app-loader>
<div class="background-gradient">
  <div class="left-rect"></div>
  <div class="right-rect"></div>
</div>
<div class="inviteinfo">
    <div class="nf-icon"></div>

    <div *ngIf="screen === 'review'" class="content-area" id="AcceptForm" [ngClass]="{'dark-theme': environment.defaultTheme === 'dark'}">
        <div class="row center">
            <div [ngClass]="environmentLogoClass" class="invite-title">New Invitation</div>
        </div>

        <div class="center-group">
            <span class="org-invite-subtitle">You've been invited to join a NetFoundry organization</span>
        </div>

        <div class="center-group">
          <div class="title row center">Your organization name is:</div>
          <div class="title row center">
              <strong class="tenant-label-title">{{ invitation['toTenantLabel'] }} </strong>
          </div>
        </div>

        <div class="center-group">
          <div class="sub-org-name-text">Please remember your organization name. You will need it for future logins</div>
          <div class="expire-subtext">This invite will expire {{ expires }}</div>
        </div>

        <div class="center-group">
            <div (click)="accept()" class="button accept-button" id="AcceptButton">Accept</div>
        </div>
        <div class="center-group">
            <span>or</span>
            <span (click)="decline()" class="goto labelLink center">Decline</span>
        </div>
    </div>

    <div *ngIf="screen === 'declined'" class="content-area">
        <div class="row center">
          <div [ngClass]="environmentLogoClass" class="invite-title">Invitation Declined</div>
        </div>
        <div class="subTitle row">
          <span class="subtitle-header">This invitation has been declined.</span>
          <span>If you believe this is an error, please contact your system administrator to request a new invitation.</span>
        </div>
    </div>

    <div *ngIf="screen === 'inuse'" class="content-area">
        <div class="row center">
          <div [ngClass]="environmentLogoClass" class="invite-title">Invitation Accepted</div>
        </div>
        <div class="subTitle row">
          <span class="subtitle-header">This invitation has already been accepted.</span>
          <span>If you believe this is an error, please contact your system administrator to request a new invitation.</span>
        </div>
    </div>

    <div *ngIf="screen === 'expired'" class="content-area">
        <div class="row center">
          <div [ngClass]="environmentLogoClass" class="invite-title">Invitation Expired</div>
        </div>
        <div class="subTitle row">
          <span class="subtitle-header">This invitation has expired.</span>
          <span>Please request a new invitation from your system administrator.</span>
        </div>
    </div>

    <div *ngIf="screen === 'revoked'" class="content-area">
        <div class="row center">
          <div [ngClass]="environmentLogoClass" class="invite-title">Invitation Revoked</div>
        </div>
        <div class="subTitle row">
          <span class="subtitle-header">This invitation has been revoked.</span>
          <span>If you believe this is an error, please contact your system administrator to request a new invitation.</span>
        </div>
    </div>

    <div *ngIf="screen === 'invalid'" class="content-area">
        <div class="row center">
          <div [ngClass]="environmentLogoClass" class="invite-title">Invitation Invalid</div>
        </div>
        <div class="subTitle row">
            <span class="subtitle-header">This invitation is invalid.</span>
            <span>Please contact your system administrator to create a new invitation.</span>
        </div>
    </div>
</div>
